module.exports = __webpack_public_path__ + "static/media/bio-hazard-eco-ecology-svgrepo-com.d6c0c92c.svg";